import React, { Component } from 'react';
import {
  Container, Divider, Grid,
} from 'semantic-ui-react';
import Loading from '../../../components/Loading';
import ListadoEpisodios from './ListadoEpisodios';
import AccionesPerfil from '../../Pacientes/components/AccionesPerfil';

class Historial extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { getHistorial, pacienteId } = this.props;
    getHistorial(pacienteId);
  }

  render() {
    const { historial, isLoading, pacienteId } = this.props;
    if (isLoading) {
      return (<Loading />);
    }

    if (historial) {
      const ep = this.props.historial.historiaClinica.episodios;
      return (
        <div>
          <Container className="container-margins">
            <Grid>
              <Grid.Row style={{ paddingBottom: 0 }}>
                <Grid.Column width={8}>
                  <h3>
                    {`${historial.nombre} ${historial.raza}`}
                    <span style={{ marginLeft: '5px', color: '#006064', fontWeight: '100' }}> / Historia Clínica</span>
                  </h3>
                </Grid.Column>
                <Grid.Column width={8} textAlign="right">
                  <AccionesPerfil showHistoriaClinica={false} idPaciente={pacienteId} buttonGroupSize="small" {...this.props} />
                </Grid.Column>
              </Grid.Row>
              <Divider />
              {
                ep.length > 0
                  ? <ListadoEpisodios episodios={ep} />
                  : (
                    <Grid.Row>
                      <Grid.Column>
                        <h3>No se encontraron episodios</h3>
                      </Grid.Column>
                    </Grid.Row>
                  )
              }
            </Grid>
          </Container>
        </div>
      );
    }

    return (<div />);
  }
}

export default Historial;



// WEBPACK FOOTER //
// ./src/routes/Historial/components/Historial.js